import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, fmtMoney, fmtNumber, imgUrl } from "@/lib/api";
import { Layout } from "@/components/Layout";

const ROWS = [
  ["price", "Price", (v) => fmtMoney(v.price)],
  ["year", "Year", (v) => v.year],
  ["mileage", "Mileage", (v) => `${fmtNumber(v.mileage)} mi`],
  ["engine", "Engine", (v) => v.engine],
  ["horsepower", "Horsepower", (v) => `${v.horsepower} hp`],
  ["transmission", "Transmission", (v) => v.transmission],
  ["drivetrain", "Drivetrain", (v) => v.drivetrain],
  ["fuel_type", "Fuel Type", (v) => v.fuel_type],
  ["mpg", "MPG", (v) => v.mpg],
  ["body_type", "Body Type", (v) => v.body_type],
  ["seats", "Seats", (v) => v.seats],
  ["location", "Location", (v) => v.location],
];

export default function Compare() {
  const [params] = useSearchParams();
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    const ids = (params.get("ids") || "").split(",").filter(Boolean);
    Promise.all(ids.map((id) => api.get(`/vehicles/${id}`).then((r) => r.data).catch(() => null)))
      .then((res) => setVehicles(res.filter(Boolean)));
  }, [params]);

  return (
    <Layout>
      <div className="container-x py-12">
        <h1 className="mb-8 font-display text-3xl font-extrabold text-slate-900 lg:text-4xl">Compare Vehicles</h1>
        {vehicles.length === 0 ? (
          <p className="text-slate-600">No vehicles selected. <Link to="/inventory" className="text-gold">Browse inventory</Link>.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-[640px] border-collapse">
              <thead>
                <tr>
                  <th className="w-40 p-3 text-left text-sm text-slate-500"></th>
                  {vehicles.map((v) => (
                    <th key={v.id} className="p-3 text-left">
                      <Link to={`/vehicle/${v.id}`}>
                        <img src={imgUrl(v.images?.[0]?.url)} alt="" className="mb-2 h-28 w-full rounded-lg object-cover" />
                        <div className="font-display font-bold text-slate-900">{v.make} {v.model}</div>
                        <div className="text-xs text-slate-600">{v.year} {v.trim}</div>
                      </Link>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ROWS.map(([key, label, fn]) => (
                  <tr key={key} className="border-t border-slate-200">
                    <td className="p-3 text-sm font-medium text-slate-600">{label}</td>
                    {vehicles.map((v) => <td key={v.id} className="p-3 text-sm text-slate-900">{fn(v)}</td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
}
